import { FC } from 'react'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import spclasses from '../../../../../SetCourseClassDirectionModal/purchase.module.css'
import infoCn from '../../../../createLinkBlockInfo.module.css'
import classes from './AdditionalCourseDiscountLabel.module.css'

const PLATFORM_CATALOG_SETTINGS_HREF =
  '/v2/platform-settings?tab=catalogSettings'

const EXTRA_COURSE_DISCOUNT_PREFILL_TOOLTIP = (
  <div className={infoCn.root}>
    <div className={infoCn.description}>
      Предзаполнение скидки берётся из таблицы «Скидка при покупке дополнительных
      курсов» по порядку (Беслатные тарифы при этом не учитываются).
    </div>
    <div className={infoCn.typesBlock}>
      Путь: Настройки платформы → Настройки каталога → Вкладка «Поп-ап записи» → «Пользователь может
      приобрести несколько курсов сразу» (таблица открывается, если чекбокс
      включён).
    </div>
    <div className={classes.linkRow}>
      <a
        className={classes.link}
        href={PLATFORM_CATALOG_SETTINGS_HREF}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => event.stopPropagation()}
      >
        Перейти к таблице скидок доп. курсов
      </a>
    </div>
  </div>
)

/** Подпись «Скидка» + ишка про источник предзаполнения. */
const AdditionalCourseDiscountLabel: FC = () => (
  <div className={spclasses.inputLabelWithInfo}>
    <div className={spclasses.inputLabel}>Скидка, руб.</div>
    <InfoComp text={EXTRA_COURSE_DISCOUNT_PREFILL_TOOLTIP} />
  </div>
)

export default AdditionalCourseDiscountLabel
